import { ScrollReveal } from '@/components/ui/scroll-reveal'

export const ProofSection = () => {
  return (
    <section className="py-20 bg-slate-50 border-y border-slate-200">
      <div className="container px-4 md:px-6 text-center max-w-4xl mx-auto">
        <ScrollReveal>
          <h2 className="text-2xl md:text-3xl font-semibold text-slate-900 mb-6">
            Resultados reais para equipas reais
          </h2>
          <p className="text-lg text-slate-600 italic">
            "Desenvolvemos aplicações utilizadas diariamente por equipas reais,
            onde a automação e a inteligência artificial reduzem carga
            operacional e aumentam o controlo do negócio. Cada solução é
            adaptada, nunca genérica."
          </p>
        </ScrollReveal>
      </div>
    </section>
  )
}
